import { render, staticRenderFns } from "./OurSolutionsScreen.vue?vue&type=template&id=c12b9d10"
import script from "./OurSolutionsScreen.vue?vue&type=script&lang=js"
export * from "./OurSolutionsScreen.vue?vue&type=script&lang=js"
import style0 from "./OurSolutionsScreen.vue?vue&type=style&index=0&id=c12b9d10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports